import styled from "styled-components";

export const InvoiceSummaryWrapper = styled.div`
  border-top: 1px solid
    var(--section-periwinkle-grey-border-color, var(--periwinkle-grey));
`;

export const InvoiceSummaryRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 0 10px 16px;
`;

export const InvoiceTotalRow = styled(InvoiceSummaryRow)`
  margin-top: 8px;
  border-top: 1px solid #000;
`;

export const Total = styled.span`
  font-size: 18px;
  font-weight: 700;
`;

export const InvoiceSummarySum = styled.div`
  padding-right: 40px;
`;

export const InvoiceName = styled.div`
  display: flex;
`;
